import * as Constants from './constants';

const initialState = {
  addOnsFromAEM: '',
  fetchE911Address: '',
  getNPANXX: '',
  hpAdded: 'N',
  homeLine: '',
  isAssignMtnSuccess: false,
  isSkip: false,
  assignMtnValue: '',
  emergencyAddress: '',
  validatee911Response: '',
  e911CallSuccess: false,
  showError: false,
  isE911Call: false,
  showAddNotification: '',
  disableButton: false,
  browserLoad: false,
  selectedProdID: '',
  selectedProdName: '',
  savedZipCode: '',
  addonRef: null,
  addonCount: 0,
  addOnApiFlag: false,
  showAddonApiError: false,
  addonInvalidCaseError: false,
  showSkipBtn: false,
  skipBtnCall: false,
  whwBasic: {},
  addonsError: false,
  addonsNtfyMsg: null,
  updateAddonsProcessstep: false,
  visionPendingApiStatus: false,
  isModalOpen: false,
  visionPendingOrder: false,
  upgradeOnlyFlow: false,
  addFeaturesRemoveLoaded: false,
  addAccessoryRemoveLoaded: false,
};

const AddonReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.ADDONS_RESPONSE_RECEIVED: {
      return { ...state, ...action.response };
    }
    case Constants.ERORR_ADDON: {
      return { ...state, showError: action.errorDetails };
    }
    case 'UPDATE_SELECT_DATA_PERK_INFO': {
      return { ...state, selectedPlanInfo: action.response };
    }
    case Constants.GET_ADDONS_AEM_SUCCESS: {
      return { ...state, addOnsFromAEM: action.response };
    }
    case Constants.FETCH_E911ADDRESS_SUCCESS: {
      return { ...state, fetchE911Address: action.response };
    }
    case Constants.GET_NPA_NXX_SUCCESS: {
      return { ...state, getNPANXX: action.response };
    }
    case Constants.GET_NPA_NXX_FAILURE: {
      return { ...state, getNPANXX: action.response };
    }
    case Constants.ASSIGN_MTN_STATUS: {
      return { ...state, isAssignMtnSuccess: action.response };
    }
    case Constants.PROMOS_RESPONSE_RECEIVED: {
      return { ...state, promos: action.response.promo };
    }
    case Constants.IS_NPA_CALL: {
      return { ...state, hpAdded: action.data };
    }
    case Constants.HOME_LINE: {
      return { ...state, homeLine: action.data };
    }
    case Constants.SKIP_STATUS: {
      return { ...state, isSkip: action.data };
    }
    case Constants.ASSIGN_ADDONS: {
      return { ...state, addonObj: action.value };
    }
    case Constants.ASSIGN_MTN_VALUES: {
      return { ...state, assignMtnValue: action.value };
    }
    case Constants.EMERGENCY_ADDRESS: {
      return { ...state, emergencyDetails: action.values };
    }
    case Constants.VALIDATE_E911_RESPONSE: {
      return { ...state, validatee911Response: action.response.data };
    }
    case Constants.E911_RESPONSE: {
      return { ...state, e911CallSuccess: action.response };
    }
    case 'IS_E911_CALL': {
      return { ...state, isE911Call: action.value };
    }
    case 'DOWNGRADE_REDEMPTION': {
      return { ...state, isDowngradeRedemption: action.value };
    }
    case Constants.SHOW_ADD_NOTIFICATION: {
      return { ...state, showAddNotification: action.data };
    }
    case 'DISABLE_BUTTON': {
      return { ...state, disableButton: action.value };
    }
    case 'BROWSER_LOAD': {
      return { ...state, browserLoad: action.response };
    }
    case 'GET_SAVED_ZIP': {
      return { ...state, savedZipCode: action.data };
    }
    case Constants.SET_SELECTED_PRODID: {
      return { ...state, selectedProdID: action.data };
    }
    case Constants.SET_SELECTED_PRODNAME: {
      return { ...state, selectedProdName: action.data };
    }
    case Constants.SET_ADDON_REFERENCE: {
      return { ...state, addonRef: action.data };
    }
    case Constants.SET_ADDON_COUNT: {
      return { ...state, addonCount: action.data };
    }
    case 'ADDONS_API_SUCCESS': {
      return { ...state, addOnApiFlag: action.response };
    }
    case Constants.SHOW_ADDON_API_ERROR: {
      return { ...state, showAddonApiError: action.errorDetails };
    }
    case Constants.ADDON_INVALIDCASE_ERROR: {
      return { ...state, addonInvalidCaseError: action.response };
    }
    case Constants.ADD_FEATURES_REMOVE_LOADED: {
      return { ...state, addFeaturesRemoveLoaded: action.response };
    }
     case Constants.ADD_ACCESSORY_REMOVE_LOADED: {
      return { ...state, addAccessoryRemoveLoaded: action.response };
    }
    case Constants.SHOW_SKIP_BTN: {
      return { ...state, showSkipBtn: action.response };
    }
    case 'SKIP_BTN_CALLED': {
      return { ...state, skipBtnCall: action.response };
    }
    case 'OPEN_MODAL': {
      return { ...state, isModalOpen: true };
    }
    case 'CLOSE_MODAL': {
      return { ...state, isModalOpen: false };
    }
    case 'WHW_BASIC_DATA': {
      return { ...state, whwBasic: action.value };
    }
    case Constants.CEF_ADDONS_API_ERROR: {
      return { ...state, addonsError: action.errorDetails, addonsNtfyMsg: action.errorMessage };
    }
    case 'ADDON_FEATURE_SUCCESS':
      return { ...state, addFeatureapiStatus: action.value };
    case 'UPDATED_ADDONS_PROCESSSTEP':
      return { ...state, updateAddonsProcessstep: action.value };
      case 'VISION_PENDING_STATUS': {
        return { ...state, visionPendingOrder: action.value };
      }
    case 'WHW_VISION_PENDING_ORDER':
      return {
        ...state,
        visionPendingApiStatus: action.value,
      };
      case 'SELECTED_WHW_CATEGORY' : 
      return{ ...state, selectedWHWCategory: action.value };
      case 'UPGRADE_ONLY_FLOW': 
      return{ ...state, upgradeOnlyFlow: action.value};
    default:
      return state;
  }
};

export default AddonReducer;
